import classNames from "classnames";
import { Button } from "../../../../../components/buttons/button";
import {
  BankLoader,
  SingleBankComponent,
} from "../../../../../components/cards/bankCard";
import { AddBankAccountModal } from "../../../../../components/modals/app_modals/AddBankAccountModal";
import { EmptyState } from "../../../../../components/states/emptyState";
import { TitleSub } from "../../../../../components/typography/titleSub";
import { useModalControl } from "../../../../../customHooks/useModalControl";
import { useLazyGetUserProfileQuery } from "../../../../../redux/features/auth/auth.api";
import { useGetMemberBankAccountsQuery } from "../../../../../redux/features/payment/payment.api";
import { useAppSelector } from "../../../../../redux/hooks";

export const BankAccounts = ({ className }: { className?: string }) => {
  const { modal, modalOpen, handleModalClose, handleModalOpen } =
    useModalControl();

  const { onboardingCompletionStatus } = useAppSelector((state) => {
    return state?.auth;
  });

  const [fetchProfileDetails] = useLazyGetUserProfileQuery();

  const {
    data: memberBankAccounts,
    isLoading: loadingMemberBankAccounts,
    refetch: refetchmemberBankAccount,
  } = useGetMemberBankAccountsQuery(undefined, {
    refetchOnMountOrArgChange: true,
  });

  return (
    <>
      <div className={classNames("px-4 md:px-8", className)}>
        <div className="flex flex-wrap gap-4 items-center justify-between">
          <TitleSub
            title="Bank Account Details"
            subtitle={"Add your personal bank account details"}
            className={`w-fit md:max-w-max`}
          />

          <Button
            text="Add account"
            icon="plus"
            onClick={() => {
              handleModalOpen("addBankAccountModal");
            }}
            type="button"
            className="!min-w-[82px] md:!min-w-[107px] !w-fit ml-auto"
            size="medium"
            loading={false}
            disabled={false}
            variation="primary"
          />
        </div>

        {loadingMemberBankAccounts ? (
          <div className="mt-8 flex flex-col gap-2">
            {[1, 2].map((k) => {
              return <BankLoader key={`${k}`} />;
            })}
          </div>
        ) : (
          <>
            {onboardingCompletionStatus?.isBankDetailsComplete ? (
              <div className="mt-8 flex flex-col gap-4">
                {memberBankAccounts?.data?.map((item, idx) => {
                  const key = `bank-info-${idx}`;

                  return (
                    <SingleBankComponent
                      accountName={item?.AccountName}
                      accountNumber={item?.AccountNumber}
                      bankName={item?.BankName}
                      canDelete={(memberBankAccounts?.data?.length ?? 0) > 1}
                      accountId={item.id}
                      onDeleteSuccess={() => {
                        refetchmemberBankAccount();
                        // Update profile and onboarding completion status
                        fetchProfileDetails();
                      }}
                      key={key}
                    />
                  );
                })}
              </div>
            ) : (
              <EmptyState
                image={
                  <img
                    src={"/assets/images/empty_state_bank.svg"}
                    alt="empty_state"
                    className=""
                  />
                }
                title="You have not added a bank account"
                className="mt-8 md:mt-20"
                onClick={() => {
                  handleModalOpen("addBankAccountModal");
                }}
              />
            )}
          </>
        )}
      </div>

      <AddBankAccountModal
        modalOpen={modalOpen && modal === "addBankAccountModal"}
        onModalClose={() => {
          handleModalClose();
        }}
        onSuccess={() => {
          refetchmemberBankAccount();
          // Update profile and onboarding completion status
          fetchProfileDetails();
          handleModalClose();
        }}
        type="member"
      />
    </>
  );
};
